import { useAppSelector } from '@/app/hooks';
import { selectToasts } from '../model/uiSlice';

/** `.toast[role=status]`, bottom centre; auto-dismissed by a listener after 2.6 s. */
export function Toasts() {
  const toasts = useAppSelector(selectToasts);
  return (
    <>
      {toasts.map((toast) => (
        <div key={toast.id} className="toast" role="status">
          {toast.message}
        </div>
      ))}
    </>
  );
}
